import { FC } from "react";
import { Filter } from "react-admin";

import SearchWithQuery from "../../../../../components/CustomSearch/SearchWithQuery";
import { clientsCollRef, sportsClubsCollRef } from "../../../../../utils/referencies";

const CoachsReservationsFilter: FC<any> = (props) => {
  const isAdmin = props.isAdmin;

  return (
    <Filter {...props}>
      <SearchWithQuery query={clientsCollRef} source="clientId" searchKey="displayName" label="Client" filterBy="id" />
      {isAdmin ? (
        <SearchWithQuery
          query={sportsClubsCollRef}
          source="coachId"
          searchKey="displayName.en"
          label="Coach"
          filterBy="id"
        />
      ) : null}
    </Filter>
  );
};

export default CoachsReservationsFilter;
